import React from 'react'
import { PagePermissionAlert } from './PagePermissionAlert'
import { useRole } from '@ztechapps/common.hook'
import { LoadingScreen } from '../page-layout/loading'

export type PageProps = {
  roleName?: string
  children?: React.ReactNode
  loadingScreen?: React.ReactNode
}

export const Page = ({ roleName, children, loadingScreen }: PageProps) => {
  const { hasRole, loading } = useRole({ roleName })

  if (loading) {
    return loadingScreen ?? <LoadingScreen />
  }

  //Show only the PagePermission alert if the role name is provided
  if (!hasRole && roleName) {
    return <PagePermissionAlert roleName={roleName} />
  }

  return children
}
